import { ref, computed } from 'vue';

import { useToggleThemeStore } from "@/stores/toggleTheme"

export function useCampaignImages() {

    const toggleThemeStore = useToggleThemeStore()

    const campaignImages = ref([]);

    const getImageByTypePriority = (images, types) => {
        for (const type of types) {
            const image = images.find(image => image.type === type);
            if (image) {
                return image;
            }
        }
        return undefined; // No matches found
    };

    const logoImage = computed(() => {
        let typePriority = ['logo', 'logo-dark'];

        if(toggleThemeStore.activeTheme === 'night'){
            typePriority = ['logo-dark', 'logo'];
        }

        const foundImage = getImageByTypePriority(campaignImages.value, typePriority);

        return foundImage;
    });
    

    const getCampaignImageUrl = (images, typePriority, conversion = 'thumb') => {
        const image = getImageByTypePriority(images, typePriority);

        if(! image){
            return null
        }

        return getImageUrl(image, conversion)
    }

    const getImageUrl = (image, conversion = 'thumb') => {

        if(image.conversions.length <= 0 ){
            return null
        }

        const conversionImage = image.conversions.find(
            image => image.conversion === conversion
        );

        if(! conversionImage){
            return null
        }

        return conversionImage.storageUrl
    }

    return {
        logoImage,
        getImageUrl,
        campaignImages,
        getCampaignImageUrl,
    };

}